import React from 'react';

export function SimpleBarChart({ data, title }) {
  if (!data || data.length === 0) {
    return <div className="text-center text-gray-400 text-sm py-8">Aucune donnee</div>;
  }
  const maxVal = Math.max(...data.map(d => d.value), 1);

  return (
    <div>
      {title && <h4 className="text-sm font-medium text-gray-600 mb-3">{title}</h4>}
      <div className="space-y-2">
        {data.map((item, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <span className="text-xs text-gray-500 w-20 truncate" title={item.label}>{item.label}</span>
            <div className="flex-1 bg-gray-100 rounded-full h-5 overflow-hidden">
              <div
                className={`h-full rounded-full ${item.color || 'bg-blue-500'} transition-all duration-500`}
                style={{ width: `${(item.value / maxVal) * 100}%` }}
              />
            </div>
            <span className="text-xs font-medium text-gray-700 w-8 text-right">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SimplePieChart({ data, title }) {
  if (!data || data.length === 0) {
    return <div className="text-center text-gray-400 text-sm py-8">Aucune donnee</div>;
  }
  const total = data.reduce((sum, d) => sum + d.value, 0);
  if (total === 0) {
    return <div className="text-center text-gray-400 text-sm py-8">Aucune donnee</div>;
  }

  let cumulAngle = 0;
  const segments = data.map(d => {
    const angle = (d.value / total) * 360;
    const startAngle = cumulAngle;
    cumulAngle += angle;
    return { ...d, startAngle, angle };
  });

  const createArc = (startAngle, angle) => {
    const start = ((startAngle - 90) * Math.PI) / 180;
    const end = ((startAngle + angle - 90) * Math.PI) / 180;
    const r = 60;
    const largeArc = angle > 180 ? 1 : 0;
    return `M 75 75 L ${75 + r * Math.cos(start)} ${75 + r * Math.sin(start)} A ${r} ${r} 0 ${largeArc} 1 ${75 + r * Math.cos(end)} ${75 + r * Math.sin(end)} Z`;
  };

  return (
    <div>
      {title && <h4 className="text-sm font-medium text-gray-600 mb-3">{title}</h4>}
      <div className="flex items-center gap-4">
        <svg width="150" height="150" viewBox="0 0 150 150">
          {segments.map((s, i) => (
            <path key={i} d={createArc(s.startAngle, s.angle)} fill={s.colorHex || '#3b82f6'} stroke="white" strokeWidth="2" />
          ))}
          <circle cx="75" cy="75" r="30" fill="white" />
          <text x="75" y="75" textAnchor="middle" dominantBaseline="middle" className="text-lg font-bold fill-gray-700">{total}</text>
        </svg>
        <div className="space-y-1.5">
          {data.map((d, i) => (
            <div key={i} className="flex items-center gap-2 text-xs">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: d.colorHex || '#3b82f6' }} />
              <span className="text-gray-600">{d.label}</span>
              <span className="font-bold text-gray-800">{d.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
